import { useCallback, useRef } from 'react';

/**
 * Tracks per-profile-session task impressions to prevent double-counting
 * during polling. Lives for the lifetime of the component using it.
 */
export const useProfileImpressionsSession = () => {
  const seenTaskIdsRef = useRef<Set<number>>(new Set());

  const hasSeen = useCallback((taskId: number) => {
    return seenTaskIdsRef.current.has(taskId);
  }, []);

  const markSeen = useCallback((taskId: number) => {
    seenTaskIdsRef.current.add(taskId);
  }, []);

  const reset = useCallback(() => {
    seenTaskIdsRef.current.clear();
  }, []);

  return { hasSeen, markSeen, reset };
};
